var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, keys, observable, makeObservable } from 'mobx';
import { runtime } from '../../../runtime/Runtime';
import { eventRegistry } from '../../../../registry/Registry';
import { cachedSet } from '../../../../utils/mobx/decorators/customComputed';
import { uniq } from '../../../../utils/helper/lodash_replacements';
import { bound } from '../../../../utils/decorators/basic';
// import { reactEventHandlers } from '../../../event/reactEventHandlers';
export class AspectEventObserve {
    parent;
    isObservingEventType = observable.map();
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspectEvent() {
        return this.parent;
    }
    get aspect() {
        return this.aspectEvent.aspect;
    }
    observeEventType(eventKey) {
        runtime.runtimeScheduler.addToNextStateChange(() => this.isObservingEventType.set(eventKey, true));
        return observable.array(undefined, { deep: false });
    }
    cleanupObservedEventType(result, eventKey) {
        runtime.runtimeScheduler.addToNextStateChange(() => this.isObservingEventType.delete(eventKey));
    }
    get observedEventKeys() {
        // MARK 1: return Array.from(this.currentlyObserved.keys()) as AnyEventRegistryKey[];
        return keys(this.isObservingEventType);
    }
    get observedEventHandlerNames() {
        return (this.observedEventKeys
            //  .filter((key: string) => reactEventHandlers.includes(key))
            .map(key => eventRegistry.registry_object[key].handlerName));
    }
    get programmaticHandlerKeys() {
        return uniq(this.aspectEvent.programmaticListeners.map(l => l[0]));
    }
    get activeEventHandlerKeys() {
        const activeTraitKeys = this.aspect.global.aspectActive.activeTraitKeys;
        const activeHandlerKeys = activeTraitKeys.filter((key) => key.startsWith('on') &&
            key.charAt(2) === key.charAt(2).toUpperCase() &&
            ![
                'onGlobalKeyDown',
                'onDirectClick',
                'onTraitBecomeActive',
                'onStepComplete',
                'onDraggableEnd',
                'onDraggableDrag',
                'onDraggableStart',
            ].includes(key));
        const observedHandlerKey = this.observedEventHandlerNames;
        return uniq([
            ...activeHandlerKeys,
            ...observedHandlerKey,
            ...this.programmaticHandlerKeys,
        ]);
    }
}
__decorate([
    observable.shallow
], AspectEventObserve.prototype, "isObservingEventType", void 0);
__decorate([
    bound
], AspectEventObserve.prototype, "observeEventType", null);
__decorate([
    bound
], AspectEventObserve.prototype, "cleanupObservedEventType", null);
__decorate([
    computed
], AspectEventObserve.prototype, "observedEventHandlerNames", null);
__decorate([
    cachedSet
], AspectEventObserve.prototype, "activeEventHandlerKeys", null);
